import { Button, Buttons, Content, Header, Item, Label, List, Modal, Title, Toolbar } from '@/ui'
import './NewsletterArchiveModal.css'

export interface NewsletterArchiveModalProps {
  isOpen?: boolean
  issues?: any[]
  onDismiss?: () => void
}

const formatDate = (dateStr?: string | null) => {
  if (!dateStr) return ''
  return new Date(dateStr + 'T12:00:00').toLocaleDateString('en-US', {
    month: 'long',
    year: 'numeric'
  })
}

const openUrl = async (url?: string | null) => {
  if (!url) return
  window.open(url, '_blank', 'noopener,noreferrer')
}

const viewPdf = (issue: any) => openUrl(issue.pdfDownloadUrl)

const downloadPdf = async (issue: any) => {
  const url = issue.pdfDownloadUrl
  if (!url) return
  const anchor = document.createElement('a')
  anchor.href = url
  anchor.download = `${issue.title || 'newsletter'}.pdf`
  anchor.target = '_blank'
  anchor.rel = 'noopener noreferrer'
  document.body.appendChild(anchor)
  anchor.click()
  document.body.removeChild(anchor)
}

export function NewsletterArchiveModal ({ isOpen = false, issues = [], onDismiss }: NewsletterArchiveModalProps) {
  return (
    <Modal isOpen={isOpen} onDidDismiss={() => onDismiss?.()} className="c-newsletter-archive-modal" ariaLabel="Newsletter archive">
      <Header>
        <Toolbar>
          <Title>Newsletter archive</Title>
          <Buttons slot="end">
            <Button fill="clear" onClick={() => onDismiss?.()}>Close</Button>
          </Buttons>
        </Toolbar>
      </Header>

      <Content padding>
        {issues.length === 0 ? (
          <p className="empty">No newsletters published yet.</p>
        ) : (
          <List lines="full">
            {issues.map((issue) => (
              <Item
                key={issue.id}
                lines="full"
                end={
                  <>
                    <Button fill="clear" onClick={() => viewPdf(issue)}>
                      View
                    </Button>
                    <Button fill="clear" onClick={() => downloadPdf(issue)}>
                      Download
                    </Button>
                  </>
                }
              >
                <Label>
                  <h2>{issue.title}</h2>
                  <p>{formatDate(issue.issueDate)}</p>
                </Label>
              </Item>
            ))}
          </List>
        )}
      </Content>
    </Modal>
  )
}
